<template>
    <div>
        <table class="table">
            <thead class="text-uppercase fs-12">
                <tr>
                    <th>{{ trans('general.page.space_billing.payments') }}</th>
                    <th class="text-end">{{ trans('general.page.space_billing.invoice.model.amount') }}</th>
                </tr>
            </thead>
            <tbody class="text-dark mt-3">
            <tr class="invoice-item fs-14"  v-for="payment in payments">
                <td class="">
                    <div><b>{{ payment.sequence }} </b></div>
                    <small>{{ payment.payment_date|moment('YYYY-MM-DD') }}</small>
                </td>
                <td class="text-end">
                    <div class="text-end text-success ">
                        {{ getCurrency() }} {{round(payment.amount_paid / 100, 2).toFixed(2) }}
                    </div>
                    <span class="text-end d-inline-block  ">
                        {{ getCurrency() }} {{round(invoice.amount / 100, 2).toFixed(2) }}
                    </span>
                </td>
            </tr>
            <tr class="invoice-item fs-14" v-if="payments.length === 0">
                <td class="text-center fw-bold text-gray-700 " colspan="3">
                    {{trans('general.page.space_billing.invoice.messages.no_payment_for_invoice')}}
                </td>
            </tr>
            </tbody>
        </table>
        <div class="text-end mt-5 col-md-5 ms-auto align-self-end" v-if="payments.length">
            <hr >
            <h5 class="fw-bolder text-success">
                {{ trans('general.defaults.total') }}:
                {{ getCurrency() }} {{ round(totalPaid/100, 2).toFixed(2) }}
            </h5>
        </div>
    </div>
</template>

<script>
import WaitingIndicatorIcon from "../../../theme/atoms/WaitingIndicatorIcon.vue";
import {
    BADGE_STYLES,
    DEFAULT_STATUS_STYLES, EMIT_SELECTED_INVOICES, getSpaceCurrency,
    STATUS_OPEN,
    statusStyle,
    transStatus
} from "../../../services/SpaceBillingContants";
import {round} from "../../../services/MathFunctions";
const LOAD_INVOICES = 'LOAD_INVOICES'
export default {
    name: "InvoicePaymentsList",
    props: {
        invoiceId: Number,
    },
    components: {
        WaitingIndicatorIcon
    },
    data() {
        return {
            currency: null,
            page:  1,
            limit:  3,
            total: 0,
            invoice: null,
            payments: [],
            statusStyles: DEFAULT_STATUS_STYLES,
            badgeStyles: BADGE_STYLES,
            LOAD_INVOICES
        }
    },
    computed: {
        totalPaid() {
            let paidAmount = 0;
            this.payments.forEach(payment => {paidAmount += payment.amount_paid});

            return paidAmount;
        }
    },
    methods: {
        round: round,
        statusStyle:statusStyle,
        transStatus: transStatus,
        getCurrency() {
            return this.currency?.symbol ?? ' '
        },
        async load() {
            this.$wait.start(LOAD_INVOICES);

            const params = {include: 'payments'};
            const response = await axios.get(`/space/billing/invoices/read/${this.invoiceId}`, {params});

            this.invoice = response.data.data ;
            this.payments = response.data.data.payments.map(v => {
                v.amount_paid = v.pivot.amount_paid;
                return v
            });

            this.$wait.end(LOAD_INVOICES);
        },

    },
    mounted() {
        this.load();
        getSpaceCurrency().then(currency => this.currency = currency)
    }
}
</script>

<style scoped>
tbody {
    margin-top: 10px;
}

tr {
    border-style: solid !important;
    border-bottom: 1px #EDF0F3;
}

tr:first-child td {
    padding-top: 0.5rem !important;
}

.invoice-item:hover {
    background-color: #f8f8f8;
    cursor: pointer;
}
</style>
